import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/cn';

type AppShellPanelProps = PropsWithChildren<{
  className?: string;
}>;

export function AppShellPanel({ children, className }: AppShellPanelProps) {
  return (
    <section className={cn('rounded bg-divergent-panel p-4 shadow-app', className)}>{children}</section>
  );
}
